import {
    Card,
    Descriptions,
    Drawer,
    Row,
    Col,
    Typography,
    Divider
}
    from "antd";

export default function OfferCard({
                                          conversation
                                      }) {

    const {
        product
    } = conversation;

    return (
        <Card>

            <Typography.Title level={5}>
                💼 Nouvelle proposition
            </Typography.Title>

            <Descriptions column={1}>

                <Descriptions.Item label="Prix">
                    16 000 FCFA
                </Descriptions.Item>

                <Descriptions.Item label="Paquet">
                    25 Kg
                </Descriptions.Item>

                <Descriptions.Item label="Disponible">
                    6 paquets
                </Descriptions.Item>

            </Descriptions>

        </Card>

    );
}